export const newrelicConfig = {
  browserApplicationId: 653447490,
  browserLicenseKey: 'NRJS-aebf7a62836ba2e6388',
  browserAccountId: 3056529,
  browserAgentId: 653447490,
  browserTrustKey: 3056529,
  iosAppToken: 'AA823a7cee0897ee05e5d9e80fbf98d62af2f52e9e-NRMA',
  androidAppToken: 'AA0c842cc70d37746c861d859ff50f99eb913063c4-NRMA',
  sessionReplayEnabled: true,
};
